<div class="cause-selection" [ngClass]="config?.formTheme">
  <div class="head">
    <div class="title">Select Your Causes</div>
  </div>
  <div class="list-section">
    <div *ngFor="let item of cause_list" class="cause" [ngClass]="{'active': selected_causes.includes(item?.type)}" (click)="causeSelect(item)">
      <div class="logo"><em class="material-icons">{{item?.icon}}</em></div>
      <div class="title">{{item?.title}}</div>
      <div class="right">
        <div *ngIf="selected_causes.includes(item?.type)" class="amount" [innerHTML]="util.formatAmount(config?.amount, config?.currency)"></div>
        <div class="check-mark"><em *ngIf="selected_causes.includes(item?.type)" class="material-icons">done</em></div>
      </div>
    </div>
  </div>
</div>
